// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_O9r64","ad_1":"index_ad_1_y6TTi","ad_2":"index_ad_2_n2BkH","logoText":"index_logoText_xDGri"};